import React from "react";
import { FaLink, FaDesktop, FaSyncAlt } from "react-icons/fa";

function WhyChooseLending() {
  const reasons = [
    {
      title: "Blockchain Expertise",
      desc: "Our engineers specialize in crafting premium architectures, guaranteeing highly scalable decentralized operations natively supported globally.",
      icon: <FaLink />,
    },
    {
      title: "User-Centric Design",
      desc: "We prioritize intuitively fluid smart interfaces accommodating novices while preserving complex portfolios efficiently.",
      icon: <FaDesktop />,
    },
    {
      title: "End-to-End Dev",
      desc: "From strategizing through audits, our execution handles all deployment domains finalizing unparalleled capabilities.",
      icon: <FaSyncAlt />,
    },
  ];

  return (
    <div className="services-area pt-120 pb-120">
      <div className="container">
        <div className="row text-center mb-5">
          <div className="col-lg-8 offset-lg-2">
            <h2
              className="title fw-extrabold mb-4"
              style={{ fontWeight: "bold" }}
            >
              Why Partner With Xeer Tech?
            </h2>
            <p className="text-muted fs-5">
              We bridge the gap between complex blockchain mechanics and
              seamless user experiences.
            </p>
          </div>
        </div>

        <div className="row g-4 justify-content-center">
          {reasons.map((reason, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <div
                className="card border-0 p-5 h-100 text-center"
                style={{
                  borderRadius: "32px",
                  background: "#ffffff",
                  boxShadow: "0 20px 40px rgba(0,0,0,0.03)",
                  transition: "all 0.3s ease",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow =
                    "0 30px 60px rgba(0,0,0,0.06)";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 20px 40px rgba(0,0,0,0.03)";
                }}
              >
                <div
                  className="icon-box mx-auto d-flex align-items-center justify-content-center mb-4"
                  style={{
                    width: "80px",
                    height: "80px",
                    fontSize: "32px",
                    backgroundColor: `${reason.color}10`,
                    color: reason.color,
                    borderRadius: "50%",
                    border: `1px solid ${reason.color}20`,
                  }}
                >
                  {reason.icon}
                </div>

                <h4 className="fw-bold mb-3">{reason.title}</h4>

                <p className="text-muted mb-0" style={{ lineHeight: "1.7" }}>
                  {reason.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default WhyChooseLending;
